// External Dependencies
import { toast } from 'react-toastify';

// Internal Dependencies
import apiService from '../services.js/apiService';
import Constants from './constants';
import { IsEmpty, IsObject } from './checks';

const env = process.env.NODE_ENV;

const util = require('util');

const shouldSkipError = (error) => {
  const statusCode = error?.data?.errorStatusCode;
  return !IsEmpty(statusCode) && Number(statusCode) < 500;
};

const logError = (error = {}) => {
  if (env === 'test' || env === 'development') {
    console.log(util.inspect(error, { depth: null }));
  } else {
    // Check if the error message should be skipped
    if (shouldSkipError(error)) {
      return;
    }

    apiService.logError(Constants.SDB, error, env)
      .catch((err) => {
        // e.g. user has no internet or Backend doesn't provide the API
        console.log('Exception logging error: ', err);
      });
  }
};

const handleError = (
  error,
  description,
  {
    additionalData = {},
    suppressToast = false,
  } = { },
) => {
  const errorMessage = error?.message || Constants.Error.UnexpectedError;
  const errorStatusCode = error?.response?.status;
  const errorStack = error?.stack || '';

  // Do not log if the error is related to any of the following error messages
  if (![
    Constants.Error.NoInternetConnection,
    Constants.Error.AccessDenied,
  ].includes(errorMessage)) {
    logError({
      description,
      data: {
        error: errorMessage,
        errorStatusCode,
        errorStack,
        ...(IsObject(additionalData) ? additionalData : {}),
      },
    });
  }

  if (!suppressToast) {
    toast.info(errorMessage);
  }
};

export {
  handleError,
  logError,
};
